import moment from "moment";
import BirthDate from "../../components/BirthDate";
import { order } from "../SmartSearchParammeter";

export default async function BirthDateSearchConfig(key) {
  return {
    description: "Birth date",
    id: "birthDateStart",
    initial: undefined,
    type: order.fourth,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <BirthDate
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    handleValues: (searchObject) => {
      return;
    },
    operation: ["Between"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["birthDateStart"] = value[0] ? moment(value[0]) : null;
      searchObj["birthDateEnd"] = value[1] ? moment(value[1]) : null;
    }
  };
}
